import StickyPageHeader from '../components/common/StickyPageHeader';
import TerminalList from '../components/lists/TerminalList';
import {
  useCarriers,
  useCarrierTerminalMap,
} from '../hooks/apiHooks';
import { useTerminals } from '../hooks/apiHooks/terminal';
import Layout from '../layout';

const AdminTerminalsPage = ({ disableLayout, routes }) => {
  const { allCarriers } = useCarriers();
  const { allTerminals } = useTerminals();
  const { carrierTerminalMap } = useCarrierTerminalMap();

  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / Terminals" />
      <TerminalList
        carriers={allCarriers}
        carrierTerminalMap={carrierTerminalMap}
        id="terminals"
        terminals={allTerminals}
      />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminTerminalsPage;
